
import React from "react";
import { ArrowLeft, ArrowRight, CheckCircle } from "lucide-react";

interface QuizControlsProps {
  onPrevious: () => void;
  onNext: () => void;
  isFirstQuestion: boolean;
  isLastQuestion: boolean;
  isCurrentQuestionAnswered: boolean;
}

const QuizControls: React.FC<QuizControlsProps> = ({
  onPrevious,
  onNext,
  isFirstQuestion,
  isLastQuestion,
  isCurrentQuestionAnswered,
}) => {
  return (
    <div className="mt-8 flex justify-between">
      <button
        onClick={onPrevious}
        disabled={isFirstQuestion}
        className={`flex items-center gap-2 px-4 py-2 rounded-md transition-all ${
          isFirstQuestion
            ? "text-gray-400 cursor-not-allowed"
            : "text-techne-blue hover:bg-techne-blue/10"
        }`}
      >
        <ArrowLeft className="w-5 h-5" />
        Previous
      </button>

      {isCurrentQuestionAnswered && (
        <button
          onClick={onNext}
          className="flex items-center gap-2 px-6 py-2 rounded-md text-white transition-all bg-techne-primaryPurple hover:bg-techne-primaryPurple/90"
        >
          {isLastQuestion ? (
            <>
              Finish
              <CheckCircle className="w-5 h-5" />
            </>
          ) : (
            <>
              Next
              <ArrowRight className="w-5 h-5" />
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default QuizControls;
